const fullName = contact => {
  if (!contact) return null;
  const { first_name: firstName, last_name: lastName } = contact;
  return [firstName, lastName].filter(name => name).join(' ');
};

export default fullName;
